import Swiper from 'swiper'
import { Autoplay, Pagination } from 'swiper/modules'
import { qs, qsa } from '@/lib/dom'

/**
 * 10TH CONTENTS 内の `.mySwiper`。
 *
 * Swiper の CSS は既存の style-10th.css にバンドル済みなので、
 * ここで swiper/css を import すると重複する。JS だけを使う。
 */
export function initCarousels(): Swiper[] {
  return qsa<HTMLElement>('.mySwiper').map((el) => {
    const pagination = qs<HTMLElement>('.swiper-pagination', el)

    return new Swiper(el, {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      loop: true,
      speed: 700,
      autoplay: { delay: 4000, disableOnInteraction: false },
      ...(pagination ? { pagination: { el: pagination, clickable: true } } : {}),
    })
  })
}
